module.exports = __webpack_public_path__ + "img/cfb-send.40aacf0e.png";